module.exports = __webpack_public_path__ + "img/右边.71631230.png";